module.exports = __webpack_public_path__ + "25d81ad3556b49e943c72f8799155dcc.png";